import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { CasesComponent } from './cases.component';

import { CaseFinanceiroModule } from './pages/case-financeiro/case-financeiro.module';
import { CaseSaoCristovaoModule } from './pages/case-sao-cristovao/case-sao-cristovao.module';
import { CaseGeneraliModule } from './pages/case-generali/case-generali.module';
import { CaseMercadoGraficoModule } from './pages/case-mercado-grafico/case-mercado-grafico.module';
import { CaseSegurosModule } from './pages/case-seguros/case-seguros.module';

import { NavegacaoModule } from '../segmentos/components/navegacao/navegacao.module';

@NgModule({
    declarations: [
        CasesComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
        
        CaseFinanceiroModule,
        CaseSaoCristovaoModule,
        CaseGeneraliModule,
        CaseMercadoGraficoModule,
        CaseSegurosModule,

        NavegacaoModule
    ],
    exports: [
        CasesComponent
    ]
})

export class CasesModule { }
